import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpLoader {
  private readonly httpLoading = new BehaviorSubject<boolean>(false);
  readonly loader$ = this.httpLoading.asObservable();

  constructor() { }

  enabled() {
    this.httpLoading.next(true);
  }

  disabled() {
    this.httpLoading.next(false);
  }
}
